export default {
  // general
  profile: "Profile",
  firstname: "Firstname",
  lastname: "Lastname",
  full_name: "Full name",
  registration_date: "Registration date",
  role: "Role",
  user_status_inactive: "Inactive",
  user_status_active: "Active",

  // search
  search_user: "Search user by name or email",
  no_user_found: "No users found",

  // actions
  create_user: "Create new user",

  // messages
  user_deleted_successfully: "User deleted successfully"
};
